import React from "react";

const AppContext = React.createContext({
    getLogo: () => {},
});

export default AppContext;
